import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
    title: Yup.string().required("This field is required"),
    alias: Yup.string().required("This field is required"),
    active: Yup.boolean().required("This field is required"),
})
